export enum EmployeeAuthProvider {
  SSO = 'sso-life',
  Password = 'password',
}
